import useSetEnv from '@global/composable/useSetEnv';
import useFormInputOrder from '@global/composable/useFormInputOrder';
import useGoToTop from '@global/composable/useGoToTop';

import useSlideNotice from '@composable/useSlideNotice';
import useNavigation from '@composable/useNavigation';

window.mercci22 = window.mercci22 || {};
window.mercci22.Notice = useSlideNotice;

const { setEnv } = useSetEnv();
const isMobile = setEnv.myEquipment();

const { formInputOrder } = useFormInputOrder();

const { navGlobal, navDesktop, navMobile } = useNavigation();

window.mercci22.constants = {
  addToCartUrl: '/Shopping/MiniCart/', // 加入迷你車
  addToCartUrl_Pre: '/Shopping/PreOrderMiniCart/', // 加入預購車
  addToWishList: '/Member/AddWishList/', // 加入願望清單
  GetBanners: '/Home/GetBanners', // 取得全域廣告
  loginMode: '/Member/IsLogin', // 取得登入狀態
  IgTag: '/Mercci22Style/GetHomeCarouselData', // ig 牆
};

window.mercci22.miniCartConfig = {
  cartCookieName: 'MiniCart',
  preCartCookieName: 'PreOrderMiniCart',
  wishlistProductSize: '.info p:nth-child(5)',
};

window.mercci22.globalConfig = {
  id: 'mercci22',
  name: 'Mercci22',
  devPort: '81',
  host: 'www.mercci22.com',
};

window.mercci22.imagePlaceholder = {
  default: 'https://static.tpx.tw/sff/mercci22/static/img/inf_800x1000.png',
};

function globalCtrl() {
  setEnv.windowReload();
  navGlobal();

  /**
   * useGoToTop
   */
  document.addEventListener('DOMContentLoaded', () => {
    const { scrollToTop, goToTopVisibility } = useGoToTop();
    if (document.querySelector('.ui-gotop')) {
      window.addEventListener('scroll', () => goToTopVisibility('.ui-gotop', 200));
      scrollToTop('.ui-gotop', 1500);
    }
  });

  formInputOrder({
    inputArray: ['#account, #username', '#password', '#captchaTxt, #LoginCode'],
    submitButton: '#btnLogin, #btnShoppingLogin',
  });

  // condition
  if (isMobile) {
    // 手機版
    navMobile();
  } else {
    // 我是電腦版
    navDesktop();
  }
}

export default globalCtrl;
